import z from 'zod';
import { SendApplicationFormTemplates } from './types';
import { SendOcaLinkSendMethods } from '@trnsact/trnsact-shared-types';

export const sendApplicationFormSchema = z
  .object({
    sendMethod: z.nativeEnum(SendOcaLinkSendMethods, {
      required_error: 'Please select a send method',
    }),
    contactDetails: z.object({
      businessName: z.string().optional(),
      firstName: z.string().min(1, 'First name is required'),
      lastName: z.string().min(1, 'Last name is required'),
      mobilePhone: z.string().length(14, 'Invalid phone number').optional(),
      email: z.string().email('Invalid email address').optional(),
    }),
    equipment: z
      .object({
        stockNumber: z.string().optional(),
        amountRequested: z.number().optional(),
        quantity: z.number().optional(),
        year: z.string().optional(),
        condition: z.string().optional(),
        serialVin: z.string().optional(),
        make: z.string().optional(),
        model: z.string().optional(),
        mileage: z.number().optional(),
        description: z.string().optional(),
      })
      .optional(),
    crediApplicationTemplate: z.nativeEnum(SendApplicationFormTemplates, {
      required_error: 'Please select a credit template',
    }),
    lenderProfileId: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    const isMobileRequired = [SendOcaLinkSendMethods.Text, SendOcaLinkSendMethods.TextAndEmail].includes(
      data.sendMethod
    );
    if (isMobileRequired && !data.contactDetails.mobilePhone) {
      ctx.addIssue({
        path: ['contactDetails', 'mobilePhone'],
        code: z.ZodIssueCode.custom,
        message: 'Mobile phone is required when sending by text or text and email',
      });
    }

    const isEmailRequired = [SendOcaLinkSendMethods.Email, SendOcaLinkSendMethods.TextAndEmail].includes(
      data.sendMethod
    );
    if (isEmailRequired && !data.contactDetails.email) {
      ctx.addIssue({
        path: ['contactDetails', 'email'],
        code: z.ZodIssueCode.custom,
        message: 'Email is required when sending by email or text and email',
      });
    }

    if (data.crediApplicationTemplate === SendApplicationFormTemplates.Lender && !data.lenderProfileId) {
      ctx.addIssue({
        path: ['lenderProfileId'],
        code: z.ZodIssueCode.custom,
        message: 'Select Lender Credit Application Template',
      });
    }
  });
